import { Counter } from "components/_charts";
import React, { Component, Fragment } from "react";

// Composant graphique pour afficher les nombres généraux du dashboard.
class GeneralNumbers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hint: false,
      data: [],
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.refreshes === prevState.refreshes || !nextProps.data) return null;

    return {
      data: nextProps.data,
      refreshes: nextProps.refreshes,
    };
  }

  render() {
    const { data } = this.state;

    return (
      <div className="general-numbers">
        <article>
          <h2>Nombre de jours</h2>
          <Counter data={data.days_number} />
        </article>
        <article>
          <h2>Nombre d'interventions SSE</h2>
          <Counter data={data.intervention_count} />
        </article>
        <article>
          <h2>Nombre d'évènements</h2>
          <Counter data={data.incident_count} />
        </article>
      </div>
    );
  }
}

export default GeneralNumbers;
